// Modul Psychológia tradingu — 3 dlhé lekcie v slovenčine.
// Každá lekcia má `contenido` štruktúrovaný (keď sú sub-položky) alebo
// `contenido_texto` markdown pre telo. Stránka detailov podporuje
// oba formáty.

export const LECCIONES_PSICOLOGIA = [
  {
    id: "los-7-errores",
    numero: 1,
    titulo: "7 Psychologických Chýb, Ktoré Ničia Účty",
    duracion: "12 min",
    descripcion: "95% obchodníkov stráca peniaze. Nie je to kvôli nedostatku technických znalostí — je to kvôli nedostatku mentálnej disciplíny. Toto je 7 najčastejších psychologických chýb a ako sa im vyhnúť.",
    contenido: [
      { tipo: "error", numero: 1, nombre: "FOMO (Fear Of Missing Out)",
        descripcion: "Vstúpiť do obchodu, pretože cena už veľa vzrástla a bojíš sa prísť o pohyb. Výsledok: kupuješ na maximách a si posledný človek, ktorý vstúpi pred pádom ceny.",
        sintomas: ["Vstupuješ bez analýzy", "Cena už vzrástla >5%", "Nemáš definovaný plán pre SL", "Cítiš naliehavosť"],
        solucion: "Akceptuj, že vždy bude ďalšia príležitosť. Ak si nevstúpil na začiatku pohybu, obchod UŽ NIE JE TVOJ. Počkaj na ďalší setup.",
        ejercicio: "Keď nabudúce pocítiš FOMO, napíš si do denníka: «Cena už vzrástla o X%. Ak teraz vstúpim, môj R:R je ___». Ak je R:R menší ako 1:2, NEVSTUPUJ." },
      { tipo: "error", numero: 2, nombre: "Revenge Trading",
        descripcion: "Po strate okamžite otváraš ďalší obchod, aby si získal späť stratené peniaze. Obchoduješ z emócií, nie zo stratégie. Výsledok: druhá strata býva väčšia ako prvá.",
        sintomas: ["Práve si prehral obchod", "Vstupuješ bez čakania na setup", "Zvyšuješ veľkosť pozície", "Cítiš hnev alebo frustráciu"],
        solucion: "Neporušiteľné pravidlo: po 2 po sebe idúcich stratách PRESTAŇ obchodovať v ten deň. Trh tam bude aj zajtra.",
        ejercicio: "Implementuj pravidlo 2 stopov: ak aktivuješ 2 stop lossy v jeden deň, zatvor platformu. Bez výnimiek." },
      { tipo: "error", numero: 3, nombre: "Posúvanie Stop Lossu",
        descripcion: "Cena sa blíži k stop lossu a namiesto toho, aby si ho nechal aktivovať, posunúš ho nižšie «dúfajúc, že sa obnoví». Výsledok: strata 1% sa zmení na 5-10%.",
        sintomas: ["Cena sa blíži k SL", "Myslíš si «ešte trochu»", "Posunul si SL viac ako raz", "Obchod trvá oveľa dlhšie, ako si plánoval"],
        solucion: "Stop loss je POSVÄTNÝ. Ak si ho dal na správne miesto pri analýze, neposúvaj ho. Ak ho posunúš, celý tvoj risk manažment je zbytočný.",
        ejercicio: "Daj si na monitor poznámku: «SL = PLÁN. PLÁN = SL. NEPOSÚVAŤ»." },
      { tipo: "error", numero: 4, nombre: "Overtrading",
        descripcion: "Nadmerné obchodovanie pri neustálom hľadaní obchodov. Nuda alebo eufória vedú k vstupu do setupov nízkej kvality. Viac obchodov = viac poplatkov = viac vystavenia riziku = viac mentálneho vyčerpania.",
        sintomas: ["Máš viac ako 5 obchodov za deň", "Aktívne hľadáš obchody", "Meníš timeframe pri hľadaní setupov", "Nevieš byť bez otvorenej pozície"],
        solucion: "Kvalita nad kvantitou. Definuj, koľko obchodov je tvoje denné maximum (odporúčané: 2-3). Ak si ich dosiahol, prestaň. Najlepší obchodníci robia málo obchodov, ale veľmi selektívne.",
        ejercicio: "Veď si záznam všetkých svojich obchodov. Na konci mesiaca porovnaj win rate prvých obchodov dňa vs posledných. Uvidíš, že posledné jsou horšie." },
      { tipo: "error", numero: 5, nombre: "Vystúpenie Pred Take Profitom",
        descripcion: "Obchod ide dobre, máš +3% a rozhodneš sa zatvoriť pred dosiahnutím TP, pretože «už si zarobil dosť» alebo zo strachu, že sa obráti. Výsledok: tvoj skutočný R:R je 1:0.8 namiesto 1:3.",
        sintomas: ["Zatváraš výherné obchody skoro", "Bojíš sa, že zisk zmizne", "Tvoj priemerný zisk je menší ako tvoje priemerné riziko"],
        solucion: "Dôveruj svojej analýze. Ak si dal TP na platnej technickej úrovni, nechaj to bežať. Môžeš použiť čiastočné uzatvorenie (zatvoriť 50% pri prvom cieli) na zníženie úzkosti.",
        ejercicio: "Do denníka si poznač cenu, na ktorej si zatvoril, a cenu, ktorú skutočne dosiahla. Kvantifikuj, koľko si «nechal na stole» tým, že si neakceptoval TP." },
      { tipo: "error", numero: 6, nombre: "Nadmerná Sebadôvera Po Víťazných Sériách",
        descripcion: "Po 5-6 po sebe idúcich výherných obchodoch zvyšuješ veľkosť pozície alebo znižuješ štandardy analýzy, pretože «si v šnúre». Pýcha predchádza pádu. Vždy.",
        sintomas: ["Máš niekoľko výherných obchodov", "Zvyšuješ veľkosť bez odôvodnenia", "Analyzuješ menej každý obchod", "Cítiš, že «nemôžeš stratiť»"],
        solucion: "Trh nevie, že máš víťaznú šnúru. Každý obchod je nezávislý. Udržiavaj rovnaké % rizika vždy.",
        ejercicio: "Definuj vopred, kedy zvýšiš veľkosť pozície: len keď kapitál vzrástol o 20%. Nie skôr." },
      { tipo: "error", numero: 7, nombre: "Nedodržiavanie Plánu Tradingu",
        descripcion: "Máš plán, ale v momente obchodovania ho ignoruješ, pretože «teraz je to iné». Bez plánu = bez disciplíny = bez konzistentných výsledkov. Plán nie je návrh, je to zákon.",
        sintomas: ["Meníš stratégiu v momente", "Obchoduješ na základe intuície", "Tvoje výsledky sú nekonzistentné", "Nemáš písomné pravidlá"],
        solucion: "Napíš si pravidlá tradingu na papier a polož ich pred monitor. Pred každým obchodom over, že spĺňa VŠETKY podmienky. Ak ich nespĺňa, nie je obchod.",
        ejercicio: "Napíš si teraz svoj plán tradingu: podmienky vstupu, SL, TP, maximum obchodov za deň, maximálny kapitál na riziko. Jedna strana, jednoduché pravidlá, bez výnimiek." },
    ],
  },
  {
    id: "reglas-trading-personal",
    numero: 2,
    titulo: "Ako Vytvoriť Svoj Osobný Obchodný Poriadok",
    duracion: "8 min",
    descripcion: "Obchodník bez pravidiel je hazardný hráč. Rozdiel medzi profesionálnym obchodníkom a strácaním nie sú technické znalosti — je to disciplína dodržiavať súbor pravidiel v akýchkoľvek trhových podmienkach.",
    contenido_texto: `Obchodník bez pravidiel je hazardný hráč. Rozdiel medzi profesionálnym obchodníkom a strácaním nie sú technické znalosti — je to disciplína dodržiavať súbor pravidiel v akýchkoľvek trhových podmienkach.

TVOJE PRAVIDLÁ MUSIA ZAHŔŇAŤ:

1. KRITÉRIÁ VSTUPU
   «Vstupujem len, keď: [vymenuj svoje špecifické podmienky]».
   Príklad: «Vstupujem len v rastúcom trende (4H), pri pullbacku na OB, s potvrdením CHoCH na 15m, s minimálnym R:R 1:2».

2. RISK MANAŽMENT
   • Moje maximálne riziko na obchod je X%.
   • Moja maximálna denná strata je X%.
   • Ak stratím X% za týždeň, ten týždeň už neobchodujem.

3. TRHOVÉ PODMIENKY
   • Neobchodujem 30 minút pred dôležitými správami.
   • Neobchodujem v pondelok pred 9:00.
   • Obchodujem len počas londýnskej alebo newyorskej session.

4. EMOČNÝ MANAŽMENT
   • Ak aktivujem 2 stopy za sebou, prestanem v ten deň.
   • Kontrolujem plán pred každým obchodom.
   • Neobchodujem, ak som unavený, nahnevaný alebo vystresovaný.

5. KONTROLA A ZLEPŠOVANIE
   • Každú nedeľu kontrolujem všetky obchody za týždeň.
   • Každý mesiac vypočítam svoje štatistiky: win rate, priemerný R:R, drawdown.

Vytlač si svoj plán. Prilep ho tam, kde ho vidíš každý deň. Čítaj ho pred každou session. Ak ho budeš dodržiavať 90 dní, staneš sa iným obchodníkom.`,
  },
  {
    id: "diario-emocional",
    numero: 3,
    titulo: "Emocionálny Obchodný Denník",
    duracion: "6 min",
    descripcion: "Najlepší obchodníci na svete vedú denník. Nezaznamenávajú len čísla (vstup, výstup, P&L), ale aj svoj mentálny stav.",
    contenido_texto: `Najlepší obchodníci na svete vedú denník. Nezaznamenávajú len čísla (vstup, výstup, P&L), ale aj svoj mentálny stav.

ŠABLÓNA ZÁPISU DO DENNÍKA:

DÁTUM: _______________
EMOCIONÁLNY STAV PRED OBCHODOVANÍM (1-10): ___
Poznámky: _______________

OBCHOD
• Pár: ___ — Smer: LONG / SHORT
• Timeframe analýzy: ___
• Dôvod vstupu: _______________
• Identifikovaný setup: _______________
• Vstup: ___  ·  SL: ___  ·  TP: ___
• Vypočítaný R:R: ___

SPRÁVA OBCHODU
• Dodržal si plán? ÁNO / NIE
• Ak nie: Prečo? _______________
• Emócie počas obchodu: _______________

VÝSLEDOK
• Výstupná cena: ___  ·  P&L: ___
• Rešpektoval si SL? ÁNO / NIE
• Rešpektoval si TP? ÁNO / NIE

PONAUČENIE Z OBCHODU
• Čo si urobil dobre? _______________
• Čo by si zlepšil? _______________

Opakuj to pri každej operácii. Po 50 obchodoch ti vzorce, ktoré ničia tvoj účet, budú jasné. A potom ich budeš môcť napraviť.`,
  },
];

export const findLeccion = (id) =>
  LECCIONES_PSICOLOGIA.find((l) => l.id === id);